import { render } from "./assets-summary-chart.vue?vue&type=template&id=839a1cac"
import script from "./assets-summary-chart.vue?vue&type=script&lang=js"
export * from "./assets-summary-chart.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/my.fastfinance.app/my.fastfinance.app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__